import store from '@/store';

export const Loader = {
	show: () => store.commit('incrementLoader'),
	hide: () => store.commit('decrementLoader'),
};
